module.exports = __webpack_public_path__ + "img/logo.ba3c9a72.svg";